module.exports = __webpack_public_path__ + "static/media/narciso-rouge.47ea516d.png";